/** @jsx jsx */
import React, { useState } from "react";
import { jsx, css } from "@emotion/core";

import { ColoredH2 } from "../../components/ColoredHeader";
import PrimaryCTAButton from "../../components/PrimaryCTA";
import FilePicker from "../../components/FilePicker";
import ValidationError from "../../components/ValidationError";
import { Redirect } from "react-router";

import { resourceUrls } from "../../config";
import { colors } from "../../theme";
import { handlePost } from "../api/handler";
import { post } from "../api";
import PageContainer from "../components/PageContainer";

const submitCertificateFile = async (
    setIsLoggedIn,
    setError,
    setIsUploading,
    setUploadComplete,
    setValidationMessage,
    file
) => {
    setValidationMessage(null);
    setIsUploading(true);

    if (file && file.size > MAX_FILE_SIZE) {
        setValidationMessage("Maximum file size is 5MB.");
        setIsUploading(false);
        return;
    }

    const formData = new FormData();
    formData.append("file", file);

    await handlePost({
        postApiCall: () =>
            post({
                url: resourceUrls.degreeCertificate.submitCertificate,
                body: formData,
            }),
        setIsLoggedIn: setIsLoggedIn,
        setError: setError,
        setIsSubmissionComplete: setUploadComplete,
    });

    setIsUploading(false);
};

const MAX_FILE_SIZE = 5000000;

const CertificateUpload = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [error, setError] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadComplete, setUploadComplete] = useState(false);

    const [file, setFile] = useState(null);
    const [validationMessage, setValidationMessage] = useState(null);

    if (uploadComplete) {
        return (
            <Redirect
                push
                to={{
                    pathname: "/secure/apply",
                }}
            />
        );
    }

    return (
        <>
            <PageContainer error={error} isLoggedIn={isLoggedIn}>
                <ColoredH2 color={colors.neutral8}>
                    Please upload a copy of your graduation certificate
                </ColoredH2>
                <p>
                    We need your graduation certificate for verification
                    purposes
                </p>
                <FilePicker
                    chosenFile={file}
                    setFile={setFile}
                    id="file-picker"
                    disabled={isUploading}
                />
                {validationMessage && (
                    <ValidationError data-testid="error-message">
                        {validationMessage}
                    </ValidationError>
                )}
                <PrimaryCTAButton
                    type="submit"
                    disabled={file === null || isUploading}
                    data-testid="upload-button"
                    onClick={() =>
                        submitCertificateFile(
                            setIsLoggedIn,
                            setError,
                            setIsUploading,
                            setUploadComplete,
                            setValidationMessage,
                            file
                        )
                    }
                >
                    {!isUploading ? "Upload →" : "Uploading..."}
                </PrimaryCTAButton>
            </PageContainer>
        </>
    );
};

export default CertificateUpload;
